import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Typography, TextField, Grid } from '@mui/material';
import { isModalOpen, setToastMessage } from '../redux/FlowReducer';
import VariableAutocomplete from '../VariableAutocomplete';
import PanelShell from './PanelShell';

const EmailPropertyPanel = ({ nodeType, nodeId, data, onChange }) => {
  const dispatch = useDispatch();
  const [to, setTo] = useState(data?.to || '');
  const [subject, setSubject] = useState(data?.subject || '');
  const [message, setMessage] = useState(data?.message || data?.body || '');

  useEffect(() => {
    setTo(data?.to || '');
    setSubject(data?.subject || '');
    setMessage(data?.message || data?.body || '');
  }, [data]);

  const handleVariableSelect = (event, variable) => {
    if (!variable) return;

    const variableName = variable.displayName || variable.name;

    setMessage(prevMessage => {
      const input = document.getElementById('emailMessage');
      const cursorPosition = input?.selectionStart || prevMessage.length;
      const newMessage =
        prevMessage.slice(0, cursorPosition) +
        `{${variableName}}` +
        prevMessage.slice(cursorPosition);
      return newMessage;
    });
  };

  if (nodeType !== 'Email') return null;

  const handleSave = () => {
    const updatedData = {
      ...data,
      to,
      subject,
      message,
      body: message, // Keep body for backward compatibility
      Title: `E-Posta: ${to}`,
      label: 'Email',
      icon: 'email-icon',
    };

    onChange(updatedData);
    dispatch(isModalOpen());
    dispatch(setToastMessage({ type: 'success', message: 'E-posta ayarları kaydedildi.' }));
  };

  return (
    <PanelShell title="E-Posta Gönder" onSave={handleSave}>
      <Grid container spacing={2} sx={{ maxWidth: '100%', overflow: 'hidden' }}>
        <Grid item xs={12}>
          <Typography variant="body2" fontWeight={600} mb={1} color="text.secondary">
            Kime
          </Typography>
          <TextField
            fullWidth
            size="small"
            value={to}
            onChange={(e) => setTo(e.target.value)}
            placeholder="mail@ornek.com"
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2" fontWeight={600} mb={1} color="text.secondary">
            Konu
          </Typography>
          <TextField
            fullWidth
            size="small"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            placeholder="E-posta konusu"
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2" fontWeight={600} mb={1} color="text.secondary">
            Mesaj
          </Typography>
          <TextField
            id="emailMessage"
            fullWidth
            size="small"
            multiline
            rows={6}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Mesaj içeriği... Aşağıdan değişken seçerek ekleyebilirsiniz"
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2" fontWeight={600} mb={1} color="text.secondary">
            Mesaja Değişken Ekle
          </Typography>
          <VariableAutocomplete
            value={null}
            onChange={handleVariableSelect}
            placeholder="Tag ve değişken ara..."
            showConstants={false}
          />
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
            Seçilen değişkenler mesaja {'{değişken_adı}'} formatında eklenecektir
          </Typography>
        </Grid>
      </Grid>
    </PanelShell>
  );
};

export default EmailPropertyPanel;
